import React, { useState, useEffect } from "react";
// import clsx from "clsx";
// import {
//   useFormChangeHandler,
//   useFormChangeHandlerV2,
// } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
import { IconTrash } from "@tabler/icons-react";
import FormGroup from "./FormGroup";
import { useProduct } from "contexts/v1/masterData/ProductContext";
import { useAgent } from "contexts/v1/masterData/AgentContext";
import { useLabel } from "contexts/v1/masterData/LabelContext";
import { useTrip } from "contexts/v1/masterData/TripContext";
import Swal from "sweetalert2";

// const animatedComponents = makeAnimated();

const CreatePage = ({
  initialData,
  onSuccess,
  onError,
  // sessions,
  customers,
  session,
  filterOptions,
}) => {
  // console.log("sessions", sessions);
  // const { products = [], refetch } = useProduct(); // Berikan default array kosong
  const { products = { data: [] } } = useProduct();
  const { agents = { data: [] } } = useAgent();
  const agentList = agents.data || [];
  // console.log("agentList", agentList);
  const productList = products.data || [];
  const { labels } = useLabel();
  const labelList = labels.data || [];
  const { trips, updateFilterTrip } = useTrip(); // 🚀 Gunakan TripContext untuk availability
  // console.log("labels", labels);
  // console.log("initial customers", customers);
  // console.log("create page filterOptions", filterOptions);

  // console.log("products", productList);
  // console.log("CreatePage session", session);

  const API_URL = "/reservation"; // API URL sesuai dengan endpoint booking Anda
  const [formData, setFormData] = useState({
    // reservation_date: filterOptions?.filters.reservation_date || "", // required|date auto hari ini
    reservation_date:
      filterOptions?.filters.reservation_date ||
      new Date().toISOString().split("T")[0],

    // reservation_date: new Date().toISOString().split("T")[0], // required|date auto hari ini
    // trip_id: "", // required|exists:App\Models\Trip,id gunakan session.id
    trip_id: session?.id || "", // required|exists:App\Models\Trip,id gunakan session.id
    track: "", // nullable|string|max:255,
    agent_id: "", // nullable|exists:App\Models\Agent,id,
    customer_id: "", // nullable|exists:App\Models\Customer,id,
    label_id: "", // nullable|exists:App\Models\Label,id,
    guest_transport: "", // 'required|in:PU,OT,
    guest_pu_time: "", // required_if:guest_transport,PU,
    guest_pu_price: 0, // required_if:guest_transport,PU|numeric|min:0,
    guest_pu_location: "", // required_if:guest_transport,PU|string|max:255,
    guest_pax: 0, // required|numeric|min:1,
    // guest_pax: calculateTotalPAX(), // required|numeric|min:1,
    guest_name: "", // required|string|max:255,
    guest_phone: "", // nullable|string|max:20,
    guest_email: "", // nullable|email,
    guest_nationality: "", // nullable|string|max:100,
    guest_mark: "", // nullable|string|max:255,
    save_guest: 1, // nullable|boolean,
    driver: "", // nullable|string|max:255,
    last_number: "", // nullable|string|max:20,
    payment_note: "", // nullable|string|max:100,
    note: "", // nullable|string|max:255,
    activities: [], // required|array
    // label_id: "", // nullable|exists:App\Models\Label,id,
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
      // console.log("useEffect initialData", initialData);
    }
  }, [initialData]);

  // Konversi data agents ke format yang sesuai untuk opsi select
  const agentOption = agentList?.map((agent) => ({
    value: agent.id,
    label: agent.name,
  }));

  // Konversi data sessions ke format yang sesuai untuk opsi select
  // const sessionOptions = sessions?.map((session) => ({
  //   value: session.id,
  //   label: `${session.name} (${session.start_time} - ${session.end_time})`,
  // }));
  // const handleChange = useFormChangeHandlerV2(setFormData);

  // 🔹 Update TripContext saat user mengganti tanggal
  const handleChange = (e, fieldName) => {
    if (fieldName) {
      setFormData((prev) => ({ ...prev, [fieldName]: e.value }));
      return;
    }

    const { id, value } = e.target;

    if (id === "reservation_date") {
      updateFilterTrip("date", value); // 🔹 Update tanggal di TripContext
    }

    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  // 🔹 Mapping data trip dari TripContext ke Select Options
  const sessionOptions =
    trips?.data?.map((trip) => ({
      value: trip.id,
      label: `${trip.name} (${trip.start_time} - ${trip.end_time}) - Sisa ${trip.remaining}`,
      remaining: trip.remaining,
    })) || [];

  // ✅ Fungsi untuk cek availability sebelum booking
  const checkAvailability = () => {
    const selectedTrip = trips.data.find(
      (trip) => trip.id === formData.trip_id
    );
    if (!selectedTrip) {
      Swal.fire("Error", "Trip tidak ditemukan!", "error");
      return false;
    }

    console.log("🚀 Trip Availability:", selectedTrip);

    if (selectedTrip.remaining < formData.guest_pax) {
      Swal.fire(
        "Fully Booked",
        `Trip ${selectedTrip.name} hanya tersisa ${selectedTrip.remaining} slot.`,
        "error"
      );
      return false;
    }

    return true;
  };

  // Konversi data labels ke format yang sesuai untuk opsi select
  const labelOption = labelList?.map((label) => ({
    value: label.id,
    label: label.name,
  }));

  // trip option isinya A dan B
  const trackOption = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
  ];

  // customers option
  const customerList = customers?.data || [];
  // const customerOption = customerList.map((customer) => ({
  //   value: customer.id,
  //   label: customer.name,
  // }));

  // const customerOption = [
  //   ...customerList.map((customer) => ({
  //     value: customer.id,
  //     label: customer.name,
  //   })),
  //   { value: "new", label: "New Customer" }, // Tambahkan opsi "New Customer"
  // ];
  const customerOption = [
    { value: "new", label: "New Customer", isNew: true }, // Tambahkan di awal
    ...customerList?.map((customer) => ({
      value: customer.id,
      label: customer.name,
    })),
  ];

  const handleCustomerChange = (selectedOption) => {
    if (selectedOption?.value === "new") {
      // Jika New Customer dipilih
      setFormData((prev) => ({
        ...prev,
        customer_id: null, // Kosongkan customer_id
        guest_name: "", // Kosongkan nama
        guest_phone: "",
        guest_email: "",
        guest_pu_location: "",
      }));
    } else {
      // Jika pelanggan dari daftar dipilih
      const selectedCustomer = customerList?.find(
        (customer) => customer.id === selectedOption?.value
      );
      // console.log("Selected Customer:", selectedCustomer); // Debug log
      setFormData((prev) => ({
        ...prev,
        customer_id: selectedCustomer?.id || null, // Simpan id pelanggan
        guest_name: selectedCustomer?.name || "", // Isi nama pelanggan
        guest_phone: selectedCustomer?.phone || "", // Isi telepon pelanggan
        guest_email: selectedCustomer?.email || "", // Isi email pelanggan
        guest_pu_location: selectedCustomer?.address || "", // Isi alamat pelanggan
      }));
    }
  };

  // console.log("formData.trip_id:", formData.trip_id);
  // console.log("sessionOptions:", sessionOptions);

  const isUpdateMode = !!initialData;

  const { createData: createBooking } = useCreateData(
    API_URL,
    "bookings"
  );
  const { updateData: updateBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "bookings"
  );

  // const handleChange = useFormChangeHandler(setFormData);

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateBooking : createBooking,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();

    // 🔍 Cek ketersediaan sebelum booking
    if (!checkAvailability()) return;

    // Validasi khusus untuk PU
    if (formData.guest_transport === "PU" && !formData.guest_pu_time) {
      alert("PU Time wajib diisi jika jenis transportasi adalah Pick Up (PU).");
      return;
    }

    // jika guest_transport adalah OT jangan kirim guest_pu_location
    if (formData.guest_transport === "OT") {
      delete formData.guest_pu_location;
    }

    // Payload data
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  const guest_transports = [
    { value: "OT", label: "OT" },
    { value: "PU", label: "Pickup & Drop" },
    { value: "P", label: "Pickup Only" },
    { value: "D", label: "Drop Only" },
  ];

  const handleProductSelect = (product) => {
    // Periksa apakah produk sudah ada di activities
    if (formData.activities?.some((item) => item.productId === product.id)) {
      return; // Jika produk sudah dipilih, abaikan
    }

    // Tambahkan produk baru ke dalam activities
    setFormData((prevFormData) => ({
      ...prevFormData,
      activities: [
        ...(prevFormData.activities || []), // Produk sebelumnya
        {
          productId: product.id,
          activity: product.name,
          price: product.price_sale,
          qty: 1, // Default qty
          // type: "product",
          type: product.id === "custom" ? "extra" : "product", // Pastikan type ada
        },
      ],
    }));
  };

  // const calculateTotalPAX = () => {
  //   const totalQty = formData.activities.reduce(
  //     (sum, item) => sum + (Number(item.qty) || 0),
  //     0
  //   );
  //   return totalQty;
  // };
  const calculateTotalPAX = () => {
    const totalQty = formData.activities.reduce((sum, item) => {
      console.log("calculateTotalPAX Item:", item); // Debug log
      const qty = Number(item.qty) || 0;
      return (
        sum +
        (item.productId === "9dfafc54-cea9-4d9b-a8ec-26cf7f35ba87"
          ? qty * 2
          : qty)
      );
    }, 0);
    return totalQty;
  };

  useEffect(() => {
    const updatedGuestPax = formData.activities.reduce(
      (sum, item) => sum + (Number(item.qty) || 0),
      0
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      guest_pax: updatedGuestPax, // Update guest_pax setiap activities berubah
    }));
  }, [formData.activities]);

  const handleActivityNameChange = (index, newName) => {
    setFormData((prevFormData) => {
      const updatedActivities = [...prevFormData.activities];
      updatedActivities[index].activity = newName;
      // console.log("Updated Activities:", updatedActivities); // Debug log
      return { ...prevFormData, activities: updatedActivities };
    });
  };

  const handlePriceChange = (index, value) => {
    // Hapus titik (.) dari input harga
    const rawValue = value.replace(/\./g, "");
    const numericValue = parseInt(rawValue, 10) || 0; // Pastikan angka valid

    // Update formData dengan harga baru
    setFormData((prevFormData) => {
      const updatedProducts = [...prevFormData.activities];
      updatedProducts[index].price = numericValue; // Update price dengan nilai angka
      return { ...prevFormData, activities: updatedProducts };
    });
  };

  const handleQuantityChange = (index, newQty) => {
    setFormData((prevFormData) => {
      const updatedActivities = [...prevFormData.activities];
      updatedActivities[index].qty = Number(newQty); // Pastikan qty adalah angka

      const updatedGuestPax = updatedActivities.reduce(
        (sum, item) => sum + (Number(item.qty) || 0),
        0
      );

      return {
        ...prevFormData,
        activities: updatedActivities,
        guest_pax: updatedGuestPax, // Perbarui guest_pax langsung
      };
    });
  };

  const handleRemoveProduct = (index) => {
    setFormData((prevFormData) => {
      const updatedActivities = prevFormData.activities.filter(
        (_, i) => i !== index
      ); // Hapus item berdasarkan indeks
      return {
        ...prevFormData,
        activities: updatedActivities,
        guest_pax: calculateTotalPAX(), // Perbarui total PAX
      };
    });
  };

  // Fungsi utilitas
  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/*Ketersediaan */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Availability</h5>
          </div>
          <div className="card-body">
            <div className="row">
              {/* Tanggal Pemesanan */}
              <FormGroup
                id="reservation_date"
                label="Booking Date"
                type="date"
                value={formData.reservation_date}
                onChange={handleChange}
                error={formError?.reservation_date}
                disabled={isSubmitting}
              />
              {/* Session Select */}
              <FormGroup
                id="trip_id"
                label="Select Trip"
                as="select"
                value={
                  sessionOptions?.find(
                    (option) => option.value === formData.trip_id
                  ) || null
                } // Pastikan ini adalah objek
                onChange={(selectedOption) =>
                  handleChange(selectedOption, "trip_id")
                } // Tangani perubahan nilai
                options={sessionOptions} // Daftar opsi
                placeholder="Select a Trip"
                error={formData.trip_id === "" ? "Please select a trip" : null}
              />
              {/* Trip Option select option A atau B*/}
              <FormGroup
                id="track"
                label="Select Option"
                as="select"
                value={
                  trackOption?.find(
                    (option) => option.value === formData.track
                  ) || null
                } // Pastikan ini adalah objek
                onChange={(selectedOption) =>
                  handleChange(selectedOption, "track")
                } // Tangani perubahan nilai
                options={trackOption} // Daftar opsi
                placeholder="Select a Trip Option"
                error={
                  formData.track === "" ? "Please select a trip option" : null
                }
              />

              {/* tampilkan hasil select trip option jika A tampilkan A jika B tampilkan B */}
              {formData.track === "A" ? (
                <div className="col-md-12 text-center">
                  <div className="alert alert-info" role="alert">
                    <h4 className="alert-heading">Trip Option A</h4>
                    <p>
                      <span style={{ fontSize: "100px", fontWeight: "bold" }}>
                        A
                      </span>
                    </p>
                  </div>
                </div>
              ) : formData.track === "B" ? (
                <div className="col-md-12 text-center">
                  <div className="alert alert-google" role="alert">
                    <h4 className="alert-heading">Trip Option B</h4>
                    <p>
                      <span style={{ fontSize: "100px", fontWeight: "bold" }}>
                        B
                      </span>
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Detail Product */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Activity Detail</h5>
          </div>
          <div className="card-body">
            <div className="row mb-4">
              <div className="col-12 d-flex justify-content-end gap-3">
                <label
                  htmlFor="productSelect"
                  className=" col-form-label d-flex justify-content-end"
                  style={{ fontSize: "14px" }}
                >
                  Activity Select:
                </label>

                <div className="col-md-8">
                  <div className="d-flex flex-wrap gap-2">
                    {productList.map((product) => (
                      <button
                        key={product.id}
                        type="button"
                        className={`btn ${
                          formData.activities?.some(
                            (item) => item.productId === product.id
                          )
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-pill`}
                        onClick={() => handleProductSelect(product)}
                      >
                        {product.name} (IDR {formatPrice(product.price_sale)})
                      </button>
                    ))}

                    {/* Custom Activity Button */}
                    <button
                      type="button"
                      className="btn btn-outline-dark btn-pill"
                      onClick={() =>
                        handleProductSelect({
                          id: "custom",
                          name: "Custom Activity",
                          price_sale: 0,
                          type: "extra",
                        })
                      }
                    >
                      + Custom Activity
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                {formData?.activities?.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 border rounded p-3 mb-2 bg-light"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">{item.activity}</h6>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveProduct(index)} // Hapus produk
                      >
                        <IconTrash size={18} />
                      </button>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4">
                        <label className="form-label">Activity</label>
                        {item.type === "extra" ? (
                          (console.log("Editable Activity:", item), // Debugging log
                          (
                            <input
                              type="text"
                              value={item.activity}
                              className="form-control"
                              onChange={(e) =>
                                handleActivityNameChange(index, e.target.value)
                              }
                            />
                          ))
                        ) : (
                          <span>{item.activity}</span>
                        )}
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">QTY</label>
                        <input
                          type="number"
                          value={item.qty}
                          min="1"
                          onChange={(e) =>
                            handleQuantityChange(index, e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-5">
                        <label className="form-label">Price</label>
                        <input
                          type="text"
                          value={formatPrice(item.price)} // Format harga yang sudah disimpan
                          className="form-control"
                          onChange={(e) =>
                            handlePriceChange(index, e.target.value)
                          } // Tangkap input pengguna
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Informasi Pelanggan */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Customer Information</h5>
          </div>

          <div className="card-body">
            <FormGroup
              id="customer_id"
              label="Select Customer"
              as="select"
              value={
                customerOption?.find(
                  (option) => option.value === formData.customer_id
                ) || null
              } // Pastikan nilai adalah objek
              onChange={(selectedOption) =>
                handleCustomerChange(selectedOption)
              } // Gunakan handleCustomerChange
              options={customerOption} // Tambahkan opsi "New Customer"
              placeholder="Select a Customer or Create New"
              error={
                formData.customer_id === "" && !formData.guest_name
                  ? "Please select a customer or add a new one"
                  : null
              }
            />
            {formData.customer_id === null && (
              <>
                {/* Guest Name */}
                <FormGroup
                  id="guest_name"
                  label="Guest Name"
                  value={formData.guest_name}
                  onChange={handleChange}
                  error={formError?.guest_name}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />
                {/* Guest guest_nationality */}
                <FormGroup
                  id="guest_nationality"
                  label="Guest National/Hotel"
                  value={formData.guest_nationality}
                  onChange={handleChange}
                  error={formError?.guest_nationality}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />

                {/* Guest Phone */}
                <FormGroup
                  id="guest_phone"
                  label="Guest Phone"
                  type="number"
                  value={formData.guest_phone}
                  onChange={handleChange}
                  error={formError?.guest_phone}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />

                {/* Guest Email */}
                <FormGroup
                  id="guest_email"
                  label="Guest Email"
                  type="email"
                  value={formData.guest_email}
                  onChange={handleChange}
                  error={formError?.guest_email}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />
              </>
            )}
            {/* PU/OT Dropdown */}
            <FormGroup
              id="guest_transport"
              label="PU/OT"
              as="select"
              value={
                guest_transports?.find(
                  (option) => option.value === formData.guest_transport
                ) || null
              }
              onChange={(selectedOption) => {
                const newValue = selectedOption?.value || "";
                setFormData((prev) => ({
                  ...prev,
                  guest_transport: newValue,
                  ...(newValue === "OT" && { guest_pu_time: "" }), // Reset PU Time jika OT dipilih
                }));
              }}
              options={guest_transports}
              error={formError?.guest_transport}
              disabled={isSubmitting}
            />
            {/* PU Time - Ditampilkan hanya jika PU dipilih */}
            {/* {formData.guest_transport === "PU" && ( selain PU juga ada P dan D */}
            {["PU", "P", "D"].includes(formData.guest_transport) && (
              <div className="bg-blue-lt p-3 rounded mt-3">
                <FormGroup
                  id="puTime"
                  label="Time"
                  type="time"
                  value={formData.guest_pu_time}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      guest_pu_time: e.target.value, // Simpan nilai waktu ke formData
                    }))
                  }
                  error={formError?.puTime}
                  disabled={isSubmitting}
                />
                {/* guest_pu_price */}
                <FormGroup
                  id="guest_pu_price"
                  label="Price"
                  type="number"
                  value={formData.guest_pu_price} //formatPrice
                  // value={formatPrice(formData.guest_pu_price)} // Format harga yang sudah disimpan
                  onChange={handleChange}
                  error={formError?.guest_pu_price}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />

                {/* guest_pu_location */}
                <FormGroup
                  id="guest_pu_location"
                  label="Location"
                  value={formData.guest_pu_location}
                  onChange={handleChange}
                  error={formError?.guest_pu_location}
                  disabled={isSubmitting}
                  additionalProps={{ style: { height: "35px" } }}
                />
              </div>
            )}

            <FormGroup
              id="guest_pax"
              label="Total PAX"
              type="number"
              // value={formData.guest_pax || 0} // Tampilkan nilai guest_pax
              // value={calculateTotalPAX()} // Hitung total PAX dari activities formData.guest = calculateTotalPAX()
              value={(formData.guest_pax = calculateTotalPAX())} // Hitung total PAX dari activities formData.guest = calculateTotalPAX()
              onChange={handleChange}
              error={formError?.guest_pax}
              // disabled={true} // Nonaktifkan input manual (karena otomatis dihitung)
              additionalProps={{ style: { height: "35px" } }}
            />

            {/* note guest_mark */}
            <FormGroup
              id="guest_mark"
              label="Guest Mark"
              value={formData.guest_mark}
              onChange={handleChange}
              error={formError?.guest_mark}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "35px" } }}
            />
          </div>
        </div>

        {/* Detail Booking */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Booking Details</h5>
          </div>
          <div className="card-body">
            <FormGroup
              id="agent_id"
              label="Select Agent"
              as="select"
              value={
                agentOption?.find(
                  (option) => option.value === formData.agent_id
                ) || null
              } // Pastikan ini adalah objek
              onChange={(selectedOption) =>
                handleChange(selectedOption, "agent_id")
              } // Tangani perubahan nilai
              options={agentOption} // Daftar opsi
              placeholder="Select a Agent"
              // error={formData.agent_id === "" ? "Please select Agent" : null}
              // disabled jika kondisi update data
              disabled={isSubmitting || isUpdateMode}
            />
            {/* select label dari labels gunakan labelList */}
            <FormGroup
              id="label_id"
              label="Select Label"
              as="select"
              value={
                labelOption?.find(
                  (option) => option.value === formData.label_id
                ) || null
              } // Pastikan ini adalah objek
              onChange={(selectedOption) =>
                handleChange(selectedOption, "label_id")
              } // Tangani perubahan nilai
              options={labelOption} // Daftar opsi
              placeholder="Select a Label"
              // error={formData.label_id === "" ? "Please select Label" : null}
            />
            {/* Driver */}
            <FormGroup
              id="driver"
              label="Driver"
              value={formData.driver}
              onChange={handleChange}
              error={formError?.driver}
              disabled={isSubmitting}
            />
            {/* Payment */}
            <FormGroup
              id="payment_note"
              label="Payment Note"
              // type="number"
              value={formData.payment_note}
              onChange={handleChange}
              error={formError?.payment_note}
              disabled={isSubmitting}
            />
            {/* 4 Last Number */}
            <FormGroup
              id="last_number"
              label="4 Last Number"
              // type="number"
              value={formData.last_number}
              onChange={handleChange}
              error={formError?.last_number}
              disabled={isSubmitting}
            />
            {/* note message */}
            <FormGroup
              id="note"
              label="Note"
              as="textarea"
              value={formData.note}
              onChange={handleChange}
              error={formError?.note}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "70px" } }}
            />
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Booking" : "Create Booking"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
